import { Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Modal, type ModalProps } from '@flecto/ui'

interface ModalConfirmationMainIdentityProps extends ModalProps {
  onConfirm: () => void
  email: string
}

export function ModalConfirmationMainIdentity({
  onConfirm,
  email,
}: ModalConfirmationMainIdentityProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_account' })

  return (
    <Modal size='md'>
      <Modal.Icon variant='warning' />
      <Modal.Title>{t('modal_confirmation_main_identity.title')}</Modal.Title>
      <Modal.Content>
        <Text>
          {t('modal_confirmation_main_identity.content', {
            replace: { email },
          })}
        </Text>
        <Text mt='md'>{t('modal_confirmation_main_identity.description')}</Text>
      </Modal.Content>
      <Modal.Cancel />
      <Modal.Submit onClick={onConfirm} />
    </Modal>
  )
}
